var _circle, _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F606(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#664E27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.67 19.376a.584.584 0 0 1-.167 1.094c-2.693.403-5.548.861-8.256 2.361 4.021.667 7.25 2.729 9.002 4.829.396.474-.099 1.116-.542.955-4.772-1.732-9.679-2.67-15.847-2.036-.485.05-.903-.231-.801-.678 1.647-7.204 10.913-9.922 16.611-6.525zM12.33 19.376a.584.584 0 0 0 .167 1.094c2.693.403 5.548.861 8.256 2.361-4.021.667-7.25 2.729-9.002 4.829-.396.474.1 1.116.542.955 4.772-1.732 9.679-2.67 15.847-2.036.486.05.903-.231.801-.678-1.647-7.204-10.913-9.922-16.611-6.525z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M49.696 34.436c-.406-.52-1.127-.43-1.913-.43H16.216c-.785 0-1.506-.09-1.912.43C10.394 39.422 14.994 54 32 54c17.007 0 21.606-14.578 17.696-19.564z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C3526",
    d: "M33.842 41.741c-.578-.014-1.469.526-1.143 1.957.163.723 1.189 1.597 1.189 2.763 0 2.372-3.777 2.372-3.777 0 0-1.166 1.026-2.04 1.191-2.763.326-1.431-.565-1.971-1.145-1.957-1.571.041-4.149 1.736-4.149 4.604 0 3.224 2.684 5.836 5.991 5.836s5.991-2.612 5.991-5.836c.001-2.867-2.578-4.563-4.148-4.604z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF717F",
    d: "M24.287 50.665c2.23.956 4.801 1.517 7.714 1.517s5.483-.561 7.712-1.517c-2.149-1.032-4.71-1.663-7.712-1.663s-5.561.631-7.714 1.663z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M46.953 36H17.047c-2.053 0-2.053 4-.053 4h30.012c2.001 0 2.001-4-.053-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F606);
export default __webpack_public_path__ + "static/media/1f606.e72bdd2d1f53a7017284fa4643f05b63.svg";
export { ForwardRef as ReactComponent };